import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

export const GmStatusBlockSkeleton = () => (
  <div className="flex w-full px-4 justify-between items-center gap-2 pb-4">
    <div className="flex w-full items-center gap-2">
      <SkeletonParent className="rounded-full size-11 shrink-0">
        <SkeletonChild />
      </SkeletonParent>

      <SkeletonParent className="rounded-lg h-5.5 max-w-40 w-full">
        <SkeletonChild />
      </SkeletonParent>
    </div>

    <SkeletonParent className="rounded-full h-4 w-[2.188rem]">
      <SkeletonChild />
    </SkeletonParent>
  </div>
);
